module.exports = __webpack_public_path__ + "static/media/predefined-template.1c98ea62.png";